import React from 'react';
import { useTranslation } from 'react-i18next';

const SWISS_CANTONS = [
  '', 'AG', 'AI', 'AR', 'BE', 'BL', 'BS', 'FR', 'GE', 'GL', 'GR', 'JU',
  'LU', 'NE', 'NW', 'OW', 'SG', 'SH', 'SO', 'SZ', 'TG', 'TI', 'UR',
  'VD', 'VS', 'ZG', 'ZH',
];

const SPECIALIZATIONS = [
  '',
  'General Practice',
  'Cardiology',
  'Dermatology',
  'Gynaecology',
  'Orthopedics',
  'Orthopedic Surgery',
  'Pediatrics',
  'Psychiatry',
  'Radiology',
  'Anesthesiology',
  'Ophthalmology',
  'Other',
];

const Step1 = ({ formData, onChange, S, inputStyle, labelStyle }) => {
  const { t } = useTranslation();
  const fields = [
    { labelKey: 'screens.claimsScreen.new.claimantName', field: 'claimantName', placeholder: 'Dr. Martin Weber', type: 'text' },
    { labelKey: 'screens.claimsScreen.new.companyPractice', field: 'company', placeholder: 'Praxis Weber GmbH', type: 'text' },
    { labelKey: 'screens.claimsScreen.new.email', field: 'email', placeholder: 'm.weber@praxis-weber.ch', type: 'email' },
    { labelKey: 'screens.claimsScreen.new.phone', field: 'phone', placeholder: '+41 21 123 45 67', type: 'tel' },
    { labelKey: 'screens.claimsScreen.new.dateOfBirth', field: 'dateOfBirth', placeholder: '', type: 'date' },
    { labelKey: 'screens.claimsScreen.new.policyNumber', field: 'policyNumber', placeholder: 'POL-RC-2026-0042', type: 'text' },
  ];
  return (
    <div>
      <div style={{ fontSize: 17, fontWeight: 700, color: S.textPrimary, marginBottom: 6 }}>{t('screens.claimsScreen.new.step1Title')}</div>
      <div style={{ fontSize: 13, color: S.textMuted, marginBottom: 24 }}>{t('screens.claimsScreen.new.step1Desc')}</div>
      {fields.map(f => (
        <div key={f.field} style={{ marginBottom: 18 }}>
          <label style={labelStyle}>{t(f.labelKey)}</label>
          <input type={f.type} placeholder={f.placeholder} value={formData[f.field]} onChange={e => onChange(f.field, e.target.value)} style={inputStyle} />
        </div>
      ))}
      <div style={{ marginBottom: 18 }}>
        <label style={labelStyle}>{t('screens.claimsScreen.new.canton')}</label>
        <select value={formData.canton || ''} onChange={e => onChange('canton', e.target.value)} style={inputStyle}>
          {SWISS_CANTONS.map(c => <option key={c || 'none'} value={c}>{c || t('screens.claimsScreen.new.selectCantonOptional')}</option>)}
        </select>
      </div>
      <div style={{ marginBottom: 18 }}>
        <label style={labelStyle}>{t('screens.claimsScreen.new.specialization')}</label>
        <select value={formData.specialization || ''} onChange={e => onChange('specialization', e.target.value)} style={inputStyle}>
          {SPECIALIZATIONS.map(s => <option key={s || 'none'} value={s}>{s || t('screens.claimsScreen.new.selectSpecializationOptional')}</option>)}
        </select>
      </div>
    </div>
  );
};

export default Step1;
